import { MODAL_Z_INDEX } from '../modal/modal.style';
import { DefaultTheme } from '../theme';

export const CSS = {
	menu: 'c-Menu',
	isOpen: 'c-Menu--Open',
	isClosed: 'c-Menu--Close',
	isClosing: 'c-Menu--Closing',
	divider: 'c-Menu__Divider',
	item: {
		container: 'c-Menu__Item',
		isSelected: 'c-Menu__Item--Selected',
	},
};

export const Style = {
	[CSS.menu]: {
		position: 'absolute',
		top: DefaultTheme.space(1),
		right: DefaultTheme.space(1),
		'min-width': '160px',
		padding: `${DefaultTheme.space(1)} 0`,
		'z-index': MODAL_Z_INDEX + 1,
		color: DefaultTheme.font.color.supporting,
		'background-color': DefaultTheme.background.offWhite,
		display: 'flex',
		'flex-direction': 'column',
		'box-shadow': DefaultTheme.shadow.box.dp4,
		opacity: 1,
		transition: 'opacity .15s ease-in-out',
	},
	[CSS.divider]: {
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
		margin: `0 ${DefaultTheme.space(1)}`,
	},
	[CSS.isClosed]: {
		display: 'none',
	},
	[CSS.isClosing]: {
		opacity: '0',
		'pointer-events': 'none',
	},
};
